module.exports = __webpack_public_path__ + "img/merchant_information.c936ec5e.png";